// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"6399539795db55ea","9260":"591100f3397934be"}[chunkId] + ".js";
};